import { createContext, useContext } from 'react'

/**
 * How a sheet names the days its page has read, where it says something is
 * not in them. The property tab reads a month at a time ("the month shown");
 * the portfolio calendar reads windows of days as it scrolls and has no month
 * to name (CAP-1418), so it provides its own words.
 */
export interface RangeWords {
  /** "No cleaning for this stay in {shown}." */
  shown: string
  /** The heading over a supply category's deliveries. */
  deliveriesHeading: string
  /** Says that a gap runs on past the days read, before them, after them or both. */
  gapContinues: (before: boolean, after: boolean) => string
}

export const MONTH_WORDS: RangeWords = {
  shown: 'the month shown',
  deliveriesHeading: 'Deliveries this month',
  gapContinues: (before, after) =>
    before && after
      ? 'This gap also runs into the previous and the next month.'
      : before
        ? 'This gap also runs into the previous month.'
        : 'This gap also runs into the next month.',
}

export const RangeWordsContext = createContext<RangeWords>(MONTH_WORDS)

export function useRangeWords(): RangeWords {
  return useContext(RangeWordsContext)
}
